import { apiEndpoints } from '@/apiEndpoints';
import { LoginFormData } from '@/types/auth/LoginFormData';
import { SignInResponse } from '@/types/auth/AuthProfile';
import { UserType } from '@/types/auth/UserType';
import { useMutation, useQuery } from '@tanstack/react-query';
import axios from 'axios';

const login = async (data: LoginFormData) =>
  axios.post<SignInResponse>(apiEndpoints.auth.signin, data);

export const useLogin = () => useMutation({ mutationFn: login });

const selectProfile = async ({
  userId,
  selectionToken,
}: {
  userId: string;
  selectionToken: string;
}) =>
  axios.post<{ accessToken: string; type: UserType; userId: string }>(
    apiEndpoints.auth.selectProfile,
    { userId },
    { headers: { Authorization: `Bearer ${selectionToken}` } },
  );

export const useSelectProfile = () =>
  useMutation({ mutationFn: selectProfile });

const switchProfile = async (userId: string) =>
  axios.post<{ accessToken: string; type: UserType; userId: string }>(
    apiEndpoints.auth.switchProfile,
    { userId },
  );

export const useSwitchProfile = () =>
  useMutation({ mutationFn: switchProfile });

const fetchProfiles = async () => {
  const { data } = await axios.get<{
    profiles: import('@/types/auth/AuthProfile').AuthProfile[];
  }>(apiEndpoints.auth.profiles);
  return data.profiles;
};

export const useAuthProfiles = (enabled: boolean) =>
  useQuery({
    queryKey: ['auth', 'profiles'],
    queryFn: fetchProfiles,
    enabled,
  });

type ImpersonateDto = {
  companyId: string;
  type: UserType;
};

const impersonate = async (data: ImpersonateDto) =>
  axios.post<{ accessToken: string; impersonatedBy: string }>(
    apiEndpoints.auth.impersonate,
    data,
  );

export const useImpersonate = () => useMutation({ mutationFn: impersonate });
